// baseReducer.ts
import { setNestedValue } from "util/CommonUtil";
import {
  SetDataAction,
  SetDataChangeAction,
  SetErrorMessageAction,
  SetForceUpdate,
  SetInputChangeAction,
  SetOperationTypeAction,
  SetViewRenderStatusAction,
} from "../interface/common";
import { ActionType } from "../util/CommonConstant";

export type BaseAction =
  | SetViewRenderStatusAction
  | SetErrorMessageAction
  | SetInputChangeAction
  | SetOperationTypeAction
  | SetDataChangeAction
  | SetDataAction<any>;

export type BaseFormActions = SetForceUpdate;

const baseReducer = (state: any, action: BaseAction): any => {
  switch (action.type) {
    // Remove this use case if not needed
    case ActionType.SET_VIEW_RENDER_STATUS:
      return {
        ...state,
        viewRenderStatus: action.payload,
      };
    case ActionType.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case ActionType.SET_OPERATION_TYPE:
      return {
        ...state,
        operationType: action.payload,
      };
    case ActionType.SET_INPUT_CHANGE:
    case ActionType.SET_DATA_CHANGE: {
      //If payload is an array
      if (Array.isArray(action.payload)) {
        return action.payload.reduce(
          (newState, change) => {
            if (change.name.includes(".")) {
              const propertyNames = change.name.split(".");
              let nestedObj = newState.data;
              for (let i = 0; i < propertyNames.length - 1; i++) {
                if (!nestedObj[propertyNames[i]]) {
                  nestedObj[propertyNames[i]] = {};
                }
                nestedObj = nestedObj[propertyNames[i]];
              }
              nestedObj[propertyNames[propertyNames.length - 1]] = change.value;
            } else {
              newState.data[change.name] = change.value;
            }
            return newState;
          },
          { ...state }
        );
      }

      if (action.payload?.name?.includes(".")) {
        const newState = setNestedValue(
          structuredClone(state),
          "data." + action.payload?.name,
          action.payload?.value
        );
        return { ...newState };
      }

      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default baseReducer;
